import React from "react";
import {ValidationDataModel} from "../../services/models/validation-model";
import DataTable, {TableColumn, TableModel} from "../datatable/DataTable";

import './ValidationDatatableRenderer.scss';

type ValidationDatatableRendererProps = {
  data: ValidationDataModel[];
}

type ValidationDatatableRendererState = {
  model: TableModel;
}

export class ValidationDatatableRenderer extends React.Component<ValidationDatatableRendererProps, ValidationDatatableRendererState> {

  columns: TableColumn[];

  constructor(props: ValidationDatatableRendererProps) {
    super(props);
    this.columns = [
      {key: 'type', label: 'Type'},
      {key: 'message', label: 'Message'}
    ];
  }

  render() {
    const data: ValidationDataModel[] = this.props.data;
    const model: TableModel = {columns: this.columns, data};

    return <DataTable model={model} className="ValidationDatatableRenderer"/>
  }
}
